import React from 'react'
import { FieldError } from './CreateAccount'
import { SEND_FORGOT_USERNAME_EMAIL } from 'requests'

const ForgotUsernameForm = ( {returnToLogin, checkEnter, ...props } ) => {
  const [ error, setError ] = React.useState('')
  const emailRef = React.useRef()

  const sendUsernameEmail = () => {
    setError('');
    SEND_FORGOT_USERNAME_EMAIL({email: emailRef.current.value},
      response =>{
        props.returnAndDisplaySuccess();
      },
      err => {
        console.error(err)
        setError(err.message)
      })
  }

  return (
    <div className='login forgot-password'>
      
      <p className='description'>
          In order to retrieve your username(s), please input the email address associated with your account.
        </p>
        <div className="field">
          <label>Email</label>
          <input
            type="text"
            ref={emailRef}
            onKeyDown={checkEnter}
            placeholder={'example@email.com'}
            maxLength={100}
          />
          <FieldError>{error}</FieldError>
        </div>
        <div className="button-wrapper create-wrapper">
          <button
            type="button"
            className="btn-raised btn-light-primary submit"
            onClick={sendUsernameEmail}
          >
            SUBMIT
          </button>
        </div>
        <div className="button-wrapper create-wrapper">
          <button
            type="button"
            className="create-account-button"
            onClick={returnToLogin}
          >
            Return to login
          </button>
        </div>
    </div>
  )
}

export default ForgotUsernameForm